import { Context, Schema } from "effect";

/** Merchant auth token sent by the merchant app's settings widget preview. */
export const WIDGET_MERCHANT_PREVIEW_TOKEN_HEADER =
  "x-redo-merchant-preview-token";

export class WidgetCustomer extends Schema.Class<WidgetCustomer>(
  "WidgetCustomer",
)({ _id: Schema.String, email: Schema.String }) {}

/** Per-request widget context from `WidgetPublic`: the `x-widget-id` team, plus
 * the bearer-token customer and merchant-preview flag when they verify for it. */
export class WidgetTeam extends Schema.Class<WidgetTeam>("WidgetTeam")({
  _id: Schema.String,
  name: Schema.String,
  createdAt: Schema.Date,
  customer: Schema.optional(WidgetCustomer),
  merchantPreview: Schema.optional(Schema.Boolean),
}) {}

export class CurrentWidget extends Context.Tag("CurrentWidget")<
  CurrentWidget,
  WidgetTeam
>() {}

export class WidgetAuthContext extends Schema.Class<WidgetAuthContext>(
  "WidgetAuthContext",
)({ team: WidgetTeam, customer: WidgetCustomer }) {}

export class CurrentWidgetCustomer extends Context.Tag("CurrentWidgetCustomer")<
  CurrentWidgetCustomer,
  WidgetAuthContext
>() {}
